import React from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import PrivateRoute from "./components/PrivateRoute";
import GuestRoute from "./components/GuestRoute";
import Home from "./components/home/Home";
import Login from "./components/Login";
import SignUp from "./components/home/SignUp";
import Contact from "./components/Contact";
import Contractor from "./components/Contractor";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import CookiePolicy from "./components/CookiePolicy";
import Dashboard from "./components/dashboard/Dashboard";
import BillingSystem from "./components/dashboard/Billing/BillingSystem";
import CustomerManagement from "./components/dashboard/Customer/CustomerManagement";
import PaymentsPortal from "./components/dashboard/Payments/PaymentsPortal";
import PublicPaymentPortal from "./components/dashboard/Payments/PublicPaymentPortal";
import Payroll from "./components/dashboard/Payments/Payroll";
import "./App.css";

const AppWrapper = () => {
  return (
    <Router>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Router>
  );
};

function App() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/login"
            element={
              <GuestRoute>
                <Login onClose={() => navigate("/")} />
              </GuestRoute>
            }
          />
          <Route
            path="/signup"
            element={
              <GuestRoute>
                <SignUp onClose={() => navigate("/")} onSuccess={() => navigate("/dashboard")} />
              </GuestRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <PrivateRoute>
                <PaymentsPortal />
              </PrivateRoute>
            }
          />
          <Route
            path="/billing"
            element={
              <PrivateRoute>
                <BillingSystem />
              </PrivateRoute>
            }
          />
          <Route
            path="/customers"
            element={
              <PrivateRoute>
                <CustomerManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/payroll"
            element={
              <PrivateRoute>
                <Payroll />
              </PrivateRoute>
            }
          />
          <Route path="/contact" element={<Contact />} />
          <Route path="/contractor" element={<Contractor />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/cookies" element={<CookiePolicy />} />
          <Route path="/pay" element={<PublicPaymentPortal />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default AppWrapper;
